// extracted by mini-css-extract-plugin
export var banner = "_pf-0";
export var settingRow = "_pf-2";
export var titleIcon = "_pf-1";